import Client from './Clients/AxiosClient'
const resource = '/monitors'

export default {
  getAll() {
    return Client.get(`${resource}/all`)
  },
}
